<template>
    <div class="aboutus-box">
        <ChildBanner :childbannerData='childbannerData' ref='childBaner' class="white"></ChildBanner>
        <DoBetter :childModle='childModleData' class="black"></DoBetter>
        <AboutBlue class="white"></AboutBlue>
        <BlueValue class="black"></BlueValue>
        <SwiperAnimer class="white"></SwiperAnimer>
    </div>
</template>
<script>
    import ChildBanner from '@/components/base/childbanner'//引入子页面的banner
    import DoBetter from '@/components/main/contact/dobetter'//引入页面说明
    import AboutBlue from '@/components/main/about/aboutblue'//引入关于蓝鲸说明
    import BlueValue from '@/components/main/about/bluevalue'//引入蓝鲸价值观
    import SwiperAnimer from '@/components/base/swiperanimer'//引入编写的swiper动画
    export default {
        name: 'AboutUs',
        data() {
            return {
                childbannerData: {
                    childbanner: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/%E7%BB%84%20753.jpg',
                    caption: 'ABOUT US',
                    title: '关于我们'
                },
                childModleData: {
                    center: '<strong>我们的创始人Big超...</strong><br/>在我做外贸服务的10年里，目睹温州制造有很多很优质的产品，例如，卫浴行业有很多很具有匠人精神的师傅，为每批水龙头严格控制几十道工序。但是到头来利润还是很少，甚至还会遭到客户无理的索赔。为什么？他们已经那么努力!<br/>因为没有品牌，因为做的是同质化的东西，因为没有利润空间！所以我想帮助优质的中国制造，包装品牌，形成影响力！就像富士康一样，虽然只是一家代工厂，但是他做的高端，基本上客户离不开他！他也通过做OEM贴牌代工（虽然利润不高）整合了很多资源，最终形成了他独特的竞争力。<br><br>这就是我做公司的核心：<br/>1. 把握客户需求：短期帮企业接到优质询盘转化优质订单，长期树立品牌，建立企业口碑和影响力。<br/>2. 不惜代价，提供好的产品和服务，与客户长期合作共赢，打造蓝鲸的口碑。',
                    title: '我们的创始人——Big超 ...',
                },
            }
        },
        components: {
            ChildBanner,
            DoBetter,
            AboutBlue,
            BlueValue,
            SwiperAnimer
        },
        methods: {
            childMethods() {
                this.$refs.childBaner.changeShow()
            }
        }
    }
</script>
<style scoped>
    .childbanner>>>.cpation {
        letter-spacing: 16px;
        max-width: 602px;
        /* font-size: 98px;
        font-weight: bold; */
    }

    .aboutus-box>>>.DoBetter {
        padding: 0;
        margin-top: 10%;
    }

    .DoBetter>>>.center-box {
        height: 900px;
        padding-left: 17.23%;
    }

    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.text-center {
        max-width: 55.17%;

    }

    .DoBetter>>>.center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 45.22%;
        height: 900px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/augustine-wong-dEAcE-KZGV8-unsplash.jpg') no-repeat center center;
        background-size: cover;
        top: -50px;
        right: -25%;
    }

    .DoBetter>>>.title-caption {
        font-family: gilroybold4;
        font-weight: bold;
        margin-bottom: 60px;
        font-size: 40px;
        line-height: 56px;
        color: rgba(28, 28, 28, 1);
        max-width: 450px;
    }

    .aboutus-box>>>.DoBetter::before,
    .DoBetter>>>.animetionLine,
    .DoBetter>>>.animetionLine::after {
        display: block;
    }

    .aboutus-box>>>.DoBetter::before {
        top: 220px;
    }

    .DoBetter>>>.animetionLine {
        top: 170px;
    }

    .DoBetter>>>.center-box::before,.DoBetter>>>.text-center strong{
        display: none;
    }

    @media(max-width: 995px) {
        .DoBetter>>>.center-box::after,
        .DoBetter>>>.title-caption,
        .aboutus-box>>>.DoBetter::before,
        .DoBetter>>>.animetionLine {
            display: none;
        }
        .DoBetter>>>.center-box {
            min-height:auto;
            height: auto;
            padding-left: 0;
            background: #ffffff url();
        }
        .DoBetter>>>.text-center {
            max-width: 100%;
        }
        .DoBetter>>>.text-center strong{
            display: block;
            font-size: 24px;
            line-height: 200%;
        } 
        .DoBetter>>>.mobile-img{
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/augustine-wong-dEAcE-KZGV8-unsplash.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 120vw;
        }

        /* 

        .aboutus-box>>>.DoBetter {
            padding: 5% 0;
        }
        .DoBetter>>>.text-center strong{
            display: block;
            font-size: 24px;
            line-height: 200%;
        } */
    }

    /* @media(max-width: 1023px) {

        .aboutus-box>>>.DoBetter::before,
        .DoBetter>>>.animetionLine,
        .DoBetter>>>.animetionLine::after {
            display: none;
        }
        .DoBetter>>>.center-box {
        height: 900px;
        padding-left:0;
    }

        .aboutus-box>>>.DoBetter {
            padding: 301px 0 1244px 0;
            padding-bottom: 1500px;
        }

        .DoBetter>>>.center-box {
            height: 2000px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/about/augustine-wong-dEAcE-KZGV8-unsplash.jpg') no-repeat center;
            background-size: 90%;
        }

        .DoBetter>>>.center-box::after {
            display: none;
        }

        .DoBetter>>>.text-center {
            max-width: 100%;
            font-size: 50px;
        }
        .DoBetter>>>.text-center strong{
            font-size: 85px;
            line-height: 200%;
        }

        .DoBetter>>>.title-caption {
            display: none;
        }
    }
    @media(max-width: 375px){
        .aboutus-box>>>.DoBetter {
            padding-bottom: 1800px;
        }
    }
    @media(max-width: 320px){
        .aboutus-box>>>.DoBetter {
            padding-bottom: 2300px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/aboutus.vue